export default {
    root: process.env.VUE_APP_URL,
    login: process.env.VUE_APP_API_URL,
    api: process.env.VUE_APP_API_URL + 'api/',
}
